// eslint-disable-next-line
import React from 'react';
import sanitizeHtml from 'sanitize-html';
import type { IListTableProps } from './types';

function ListTable({ callerName = '', clickHandler = () => {}, list = [] }: IListTableProps) {
  return (
    <div className='tdtk-item-list tdtk-item-list-simple'>
      <ul>
        {list.map((listItem) => (
          <li key={listItem.id}>
            <div className='tdtk-item-text'>
              <a
                className='cb-blue5-color'
                data-automation={`listtable-item-${callerName}`}
                href={listItem.url}
                onClick={(e) => {
                  clickHandler(e, listItem.url);
                }}
              >
                <p
                  className='tdtk-item-title cb-roboto-bold mb-4'
                  data-automation={`${callerName}-${listItem.label.split(' ').join('-').toLowerCase()}`}
                >
                  {listItem.label}
                </p>
                {listItem.description ? (
                  <p className='mb-4 cb-gray1-color'>{sanitizeItemDescription(listItem.description)}</p>
                ) : null}
              </a>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

function sanitizeItemDescription(input: string) {
  return sanitizeHtml(input, {
    allowedTags: [],
    allowedAttributes: {},
  });
}

export default ListTable;
